export default __webpack_public_path__ + "static/media/book-white.e600d82f.svg";